<template>
  <van-popup
    class="dialog-qingsu-channel"
    v-model="showPopup"
    :overlay-style="{
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    }"
    :close-on-click-overlay="false"
  >
    <div class="wrapper">
      <div class="content">
        <div class="title">
          {{ config.title }}
        </div>
        <div class="tipTitle">
          {{ config.tipTitle }}
        </div>
      </div>
      <div class="btns-group">
        <div
          class="btn"
          v-for="(item, index) in config.btns"
          :key="index"
          @click="item.onClick(index)"
          :style="{ ...item.style }"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'

export default {
  components: {
    [Popup.name]: Popup
  },
  props: {
    page_popup: {
      type: Object,
      default: () => ({})
    },
    userInfo: {
      type: [Array, Object],
      default: () => ({})
    },
    channelInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    userId() {
      if (this.userInfo && this.userInfo.id) {
        return this.userInfo.id
      }
      return ''
    },
    cid() {
      return this.$route.query.cid || ''
    }
  },
  data() {
    return {
      showPopup: false,
      config: {
        title: '',
        tipTitle: '',
        btns: []
      }
    }
  },
  created() {
    const { expire_popup, expire_subtitle, expire_title } = this.page_popup
    const status = +this.channelInfo.status
    //当前倾诉渠道关闭
    if (!status && +expire_popup) {
      this.config = {
        title: expire_title,
        tipTitle: expire_subtitle,
        btns: [
          {
            label: '立即前往',
            onClick: () => {
              this.routerPush({ path: '/qingsu' }, 'https://m.xinli001.com')
            }
          }
        ]
      }
      this.open()
      this.clearStorage('FIRST_TIME')
      this.clearStorage('COUPON')
      return
    }
    const cacheKey = this.getCacheKey('FIRST_TIME')
    const isOpen = this.getStorage(cacheKey)
    const { first_visit_popup, first_visit_subtitle, first_visit_title } =
      this.page_popup
    // 只弹一次
    if (!isOpen && +first_visit_popup) {
      this.config = {
        title: first_visit_title,
        tipTitle: first_visit_subtitle,
        btns: [
          {
            label: '立即倾诉',
            onClick: () => {
              this.close()
            }
          }
        ]
      }
      localStorage.setItem(cacheKey, true)
      this.open()
      return
    }
    this.$emit('hide')
  },
  methods: {
    getCacheKey(type) {
      return this.userId
        ? `CHANNEL_${this.cid}_${this.userId}_${type}_OPEN`
        : `CHANNEL_${this.cid}_VISITOR_${type}_OPEN`
    },
    getStorage(key) {
      return JSON.parse(localStorage.getItem(key)) || ''
    },
    clearStorage(type) {
      const cacheKey = this.getCacheKey(type)
      localStorage.removeItem(cacheKey)
    },
    open() {
      this.showPopup = true
    },
    close() {
      this.showPopup = false
      let timer = setTimeout(() => {
        clearTimeout(timer)
        this.$emit('hide')
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-qingsu-channel {
  background: transparent;
  .wrapper {
    width: 560px;
    background: #fff;
    border-radius: 30px;
    box-sizing: border-box;
    padding: 60px 0 38px;
    text-align: center;
  }
  .content {
    padding: 0 95px;
  }
  .title {
    font-size: 32px;
    font-weight: 600;
    color: #21252d;
    line-height: 48px;
  }
  .tipTitle {
    font-size: 28px;
    color: #6c798c;
    line-height: 49px;
    margin-top: 20px;
  }
  .btns-group {
    @include flex(row, center, center);
    margin-top: 60px;
  }
  .btn {
    flex: 1;
    height: 40px;
    font-size: 32px;
    font-weight: 600;
    color: #9da3ac;
    line-height: 40px;
    &:last-child {
      border-left: 2px solid #f3f4f5;
      color: #ff745b;
    }
  }
}
</style>
